import { Component } from '@angular/core';

/**
 * Casca da tela master de "Comissoes".
 *
 * Renderiza um cabecalho de pagina e um p-tabView com duas abas:
 *  - "Repasse de Comissoes": subcomponente `app-repasse-comissoes`
 *    (listagem global de comissoes + repasse/cancelamento).
 *  - "Historico de Pagamentos": subcomponente `app-historico-pagamentos`
 *    (historico read-only dos eventos de pagamento + comprovante PDF).
 *
 * Acesso restrito via `masterAccessGuard` na rota `/contador/comissoes`.
 */
@Component({
  selector: 'app-comissoes',
  templateUrl: './comissoes.component.html',
  styleUrls: ['./comissoes.component.scss'],
})
export class ComissoesComponent {}
